import React, { ReactElement } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

import { Spacing } from '../../style'
import { Breadcrumb, BreadcrumbData } from '../navigation'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    zIndex: 100,
  },
  breadcrumb: {
    flex: undefined,
    marginHorizontal: Spacing.L,
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: Spacing.L,
    alignItems: 'center',
    marginTop: Spacing.M,
  },
  title: {
    marginRight: Spacing.L,
  },
  top: {
    flexDirection: 'row',
    zIndex: 100,
  },
  skeletonContainer: {
    marginLeft: Spacing.S,
  },
  skeletonTop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  skeletonBreadcrumb: {
    minWidth: 200,
  },
  skeletonContent: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: Spacing.L,
    marginTop: Spacing.M,
    justifyContent: 'space-between',
  },
  skeletonTitle: {
    minWidth: 200,
    marginLeft: -Spacing.M,
  },
})

export interface Props extends ViewProps {
  breadcrumb?: BreadcrumbData[]
  menu?: ReactElement
  title?: string
  titleRight?: string
  accessory?: ReactElement
  contentContainerStyle?: StyleProp<ViewStyle>
}

const Header = (props: Props) => {
  const { breadcrumb, menu, title, titleRight, accessory, contentContainerStyle, style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.top}>
        {breadcrumb && <Breadcrumb style={styles.breadcrumb} data={breadcrumb} />}
        {menu}
      </View>
      {(title || accessory) && (
        <View style={[styles.content, contentContainerStyle]}>
          <Text level={1} style={styles.title}>
            {title}
            {titleRight ? ` ${titleRight}` : ''}
          </Text>
          {accessory}
        </View>
      )}
    </View>
  )
}

interface SkeletonProps extends ViewProps {
  breadcrumb?: true
  title?: true
  accessory?: ReactElement
}
Header.Skeleton = (props: SkeletonProps) => {
  const { breadcrumb, title, accessory, style, ...otherProps } = props
  return (
    <View style={[styles.container, styles.skeletonContainer, style]} {...otherProps}>
      <View style={[styles.top, styles.skeletonTop]}>
        {breadcrumb && <Text.Skeleton style={styles.skeletonBreadcrumb} />}
      </View>
      <View style={styles.skeletonContent}>
        {title && <Text.Skeleton level={1} style={styles.skeletonTitle} />}
        {accessory}
      </View>
    </View>
  )
}

export default Header
